module.exports = __webpack_public_path__ + "media/img/masks/icon-status-271d60bec6b0bb85a7ec1fd4d14524ab.svg";